/**
 * @param {string} url 请求地址
 * @param {object} data 请求参数
 * @param {string} method 请求方法
 */
const request = (url, data, method) => {
	
	return new Promise((resole, reject) => {
		uni.request({
			url: `http://192.168.0.15:10012/web/${url}`,
			method,
		    data,
			header: {
				token: token ? token : ''
			},
		    success: (res) => {
				if (res.data.code === 200) {
					resole(res.data)
				} else {
					uni.showToast({
						title: res.data.msg,
						icon: 'error',
						duration: 2000
					});
					reject()
				}
		    },
			fail(err) {
				reject()
				uni.showToast({
					title: err,
					icon: 'error',
					duration: 2000
				});
			}
		})
	})
}

const get = (url, data) => request(url, data, 'GET')

const post = (url, data) => request(url, data, 'POST')

export {
	get, post
}